import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=cea6b85c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cea6b85c')) {
      api.createRecord('cea6b85c', component.options)
    } else {
      api.reload('cea6b85c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=cea6b85c&", function () {
      api.rerender('cea6b85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HcsfLmTCT8Zd/JS/comp/IncreaseNumber.vue"
export default component.exports